import React from "react";
import { IoMdHeartEmpty } from 'react-icons/io';
import { BsBag } from 'react-icons/bs';
import collection1 from "../../assets/collection1.svg"
import collection2 from '../../assets/collection2.svg';
import collection3 from '../../assets/collection3.svg';
import collection4 from '../../assets/collection4.svg';
import divider from "../../assets/divider.svg"
import { Button } from "@chakra-ui/react";
import woman from "../../assets/woman.png"
import cow from "../../assets/cow.svg"
import {Link } from 'react-router-dom';
import { useFilterContext } from "../../context/filter_context";
import ProductGridView from "../../pages/ProductPage/ProductGridView";
import ProductList from "../../pages/ProductPage/ProductList";
import { useProductsContext } from "../../context/products_context";
import FilterLoader from "../FilterLoader/FilterLoader";
import Loading from "../Loading";

const Collections=()=>{
const {products, products_loading } = useProductsContext();

    return (
      <div className='flex flex-col bg-white h-auto w-full p-4'>
        <h1 className='flex justify-center items-center text-[#010535] font-[600] text-xl mb-2'>
          Shop by collection
        </h1>
        <div className='flex justify-center items-center py-2 gap-3 '>
          <div className='border border-x-2 border-[#F4B41A] w-[30%]'></div>
          <img src={divider} />
          <div className='border border-[#F4B41A] w-[30%]'></div>
        </div>
        {products_loading && products?.length <= 0 && <Loading />}

        <div className='mx-auto w-full grid grid-flow-row lg:grid-cols-5 md:grid-cols-3 grid-cols-2 gap-4 px-auto overflow-hidden'>
          {!products_loading &&
            products?.length > 0 &&
            products
              ?.filter((item, index) => index < 5)
              ?.map((e) => {
                return (
                  <div className=''>
                    <ProductList data={e} id={e.id} />
                  </div>
                );
              })}
        </div>

        <div className='flex justify-center items-center py-2 gap-2'>
          <div className='border border-x-2 border-[#F4B41A] w-[30%]'></div>
          <Link to='/collections'>
            <Button backgroundColor='#D3A143' color='white' fontWeight={400}>
              View More
            </Button>
          </Link>
          <div className='border border-[#F4B41A] w-[30%]'></div>
        </div>
        <div className='flex flex-col md:flex-row justify-evenly w-full gap-5 my-4'>
          <div className='flex flex-col gap-8 justify-center items-start max-w-[480px]'>
            <h1 className='text-[#010535] font-normal lg:text-4xl text-xl flex items-end gap-2'>
              <span className='font-medium lg:text-6xl text-3xl'>Gifts</span> of the season
            </h1>
            <p className="flex w-full justify-center items-center">
              When it comes to celebrations we strive to make your experience<br/>
              as brilliant as our jewellery with the perfect pieces for every<br/>
              occasion
            </p>
            <p>
              When it comes to celebrations we strive to make your experience<br/> as
              brilliant as our jewellery with the perfect pieces for every<br/>
              occasion.
            </p>
            <Link to="/collections">
              <Button backgroundColor='#D3A143' color='white' fontWeight={400}>
                Explore our offers
              </Button>
            </Link>
          </div>
          <div className='bg-[#D9D9D9] rounded-lg mr-4'>
            <div>
              <img src={woman} />
            </div>
          </div>
        </div>
      </div>
    );



}

export default Collections